import { withStore } from 'store';
import { withLayout } from 'hocs';

import MyGuestsCompanion  from './MyGuestsCompanion';
import { useWindowSize } from 'hooks';
import BarMobile from 'pages/Header/Content/components/BarMobile';

const MyGuestAddWeb = withLayout(withStore(
  {
    mapStateToProps: (state) => ({
      tableInfo: state.giftTable.giftTable
    }),
  }
)(MyGuestsCompanion));

const MyGuestAddMobile = withStore(
  {
    mapStateToProps: (state) => ({
      tableInfo: state.giftTable.giftTable
    }),
  }
)(MyGuestsCompanion);

function GuestsCompanion() {
  const [, { isMobile }] = useWindowSize();

  return (
    <div>
      {isMobile ? (
        <>
        <BarMobile
          pageName='Lista de invitados'
          marginBottom={32}
        />
        <MyGuestAddMobile />
        </>
      ) : (
        <MyGuestAddWeb />
      )}
    </div>
  );
}

export default GuestsCompanion;